// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormAddIfrPlan } from '../../forms/FormAddIfrPlan/FormAddIfrPlan';

// props
export interface DialogAddIfrPlanProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogAddIfrPlan = ({ isOpen, onClose, onSuccess }: DialogAddIfrPlanProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('addPlan'),
					form: 'form-add-plan',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			onClose={onClose}
			title={{
				children: t('addPlan'),
				variant: 'h3',
			}}>
			<FormAddIfrPlan onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
